import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

const axiosClient = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
})
// Add a request interceptor
axiosClient.interceptors.request.use(function (config: AxiosRequestConfig) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axiosClient.interceptors.response.use(function (response: AxiosResponse) {
    return response.data;
}, function (error) {
    // // Auto logout khi server trả 401 cho các endpoint không phải account
    // // (account/info, account/login, account/token/refresh tự xử lý riêng)
    // if (error?.response?.status === 401) {
    //     const url: string = error?.config?.url || '';
    //     const isAccountEndpoint = url.includes('/account/');
    //     const hasToken = !!localStorage.getItem('access_token');
    //     if (!isAccountEndpoint && hasToken) {
    //         localStorage.removeItem('access_token');
    //         localStorage.removeItem('refresh_token');
    //         window.location.reload();
    //     }
    // }
    return Promise.reject(error);
});

export { axiosClient };
